const ADDON_KEY = plugin.addonKey;

export default {
  getAddIssueTypePath() {
    const contextPath = window.AJS.contextPath();
    return `${contextPath}/download/resources/${ADDON_KEY}:downloadable-resources/images/addIssueType.png`;
  },

  getAddTestCasePath() {
    const contextPath = window.AJS.contextPath();
    return `${contextPath}/download/resources/${ADDON_KEY}:downloadable-resources/images/addTestCase.png`;
  },

  getExecuteTestCasePath() {
    const contextPath = window.AJS.contextPath();
    return `${contextPath}/download/resources/${ADDON_KEY}:downloadable-resources/images/executeTestCase.png`;
  },

  getManageInTestCyclePath() {
    const contextPath = window.AJS.contextPath();
    return `${contextPath}/download/resources/${ADDON_KEY}:downloadable-resources/images/manageInTestCycle.png`;
  },

  getReportingPath() {
    const contextPath = window.AJS.contextPath();
    return `${contextPath}/download/resources/${ADDON_KEY}:downloadable-resources/images/reporting.png`;
  },

  getTestCaseRepositoryPath() {
    const contextPath = window.AJS.contextPath();
    return `${contextPath}/download/resources/${ADDON_KEY}:downloadable-resources/images/testCaseRepository.png`;
  },

  getFolder() {
    const contextPath = window.AJS.contextPath();
    return `${contextPath}/download/resources/${ADDON_KEY}:downloadable-resources/images/folder.png`;
  },

  getPermissions() {
    const contextPath = window.AJS.contextPath();
    return `${contextPath}/download/resources/${ADDON_KEY}:downloadable-resources/images/permissions.png`;
  },
};
